import React from 'react';
// Components
import DesignRequestsTable from 'components/common/DesignRequestsTable/DesignRequestsTable';

const DesignRequests = (): JSX.Element => {
  return <DesignRequestsTable />;
};

export default DesignRequests;
